export default __webpack_public_path__ + "static/unico-digital-internacional-5f53082d979dd5fd744f209a75cea096.jpg";